
const Spinner = () => {
    return ( 
        <span className="loading loading-spinner loading-lg mt-12"></span>
     );
}
 
export default Spinner;